import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';
import { LeaderboardAggregatesRequest } from 'src/app/interfaces/leaderboard/request/ileaderboard-aggregate';
import { LeaderboardAggregatesResponse } from 'src/app/interfaces/leaderboard/response/ileaderboard-aggregate';

@Injectable({
  providedIn: 'root',
})
export class LeaderboardService {
  backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getAssignmentByAccount(accountUuid: string, options?: { context?: HttpContext }): Observable<any[]> {
    let url = `${this.backendUrl}/leaderboard/findPracticeModuleAssignmentsByAccount?accountUuid=${accountUuid}`;

    return this.http.get<any[]>(url, options).pipe(
      tap((res) => console.log('Fetched assignments:', res)),
      catchError((error) => {
        return this.errorHandlingService.handleError<any>(
          `/leaderboard/findPracticeModuleAssignmentsByAccount?accountUuid=${accountUuid}`
        )(error);
      })
    );
  }

  getSimulationByModuleAssignment(
    moduleAssignmentUuid: string,
    accountUuid: string,
    options?: { context?: HttpContext }
  ): Observable<any[]> {
    let url = `${this.backendUrl}/leaderboard/findCallsByModuleAssignment?moduleAssignmentUuid=${moduleAssignmentUuid}&accountUuid=${accountUuid}`;

    return this.http.get<any[]>(url, options).pipe(
      tap((res) => console.log('Fetched simulations:', res)),
      catchError((error) => {
        return this.errorHandlingService.handleError<any>(
          `/leaderboard/findCallsByModuleAssignment?moduleAssignmentUuid=${moduleAssignmentUuid}&accountUuid=${accountUuid}`
        )(error);
      })
    );
  }

  findLeaderboardAggregates(
    request: LeaderboardAggregatesRequest,
    options?: { context?: HttpContext }
  ): Observable<LeaderboardAggregatesResponse> {
    let url = `${this.backendUrl}/leaderboard/findLeaderboardAggregates`;

    return this.http.post<LeaderboardAggregatesResponse>(url, request, options).pipe(
      tap((res) => console.log('Fetched leaderboard aggregates:', res)),
      catchError((error) => {
        return this.errorHandlingService.handleError<LeaderboardAggregatesResponse>(
          `/leaderboard/findLeaderboardAggregates`
        )(error);
      })
    );
  }
}
